import React from 'react';
import { StockItem } from '../types';
import { AlertTriangle } from 'lucide-react';

interface LowStockDashboardProps {
  stockItems: StockItem[];
}

export default function LowStockDashboard({ stockItems }: LowStockDashboardProps) {
  const lowStock = stockItems.filter(item => item.active && item.quantity <= (item.minLimit || 5));

  if (lowStock.length === 0) return null;

  return (
    <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-amber-100 text-amber-700 rounded-lg">
          <AlertTriangle className="w-5 h-5" />
        </div>
        <div>
          <p className="text-[10px] font-bold text-amber-950 uppercase">Alerta Crítico de Estoque</p>
          <p className="text-xs text-amber-800 font-semibold">{lowStock.length} produto(s) abaixo do limite mínimo</p>
        </div>
      </div>
      <div className="text-xs">
        {lowStock.slice(0, 3).map(item => (
          <p key={item.id} className="text-amber-900 font-medium truncate max-w-[150px]">
            {item.name}: <span className="font-bold">{item.quantity} un</span>
          </p>
        ))}
        {lowStock.length > 3 && <p className="text-amber-700 font-bold text-[10px]">...e mais {lowStock.length - 3}</p>}
      </div>
    </div>
  );
}
